module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_return.90f0b.png";